<template lang="pug">
  div
    h6 待補藥清單
      small （已列入為補藥規劃
       
    form.form-inline(@submit.prevent="onFilterSet")
      select.form-control.mr-2(v-model="systemId")
        option(:value="undefined") 選擇系統
        option(v-for="sys in systems" :value="sys.id") {{ sys.name }}
      
      button.btn.btn-primary(type="submit") 搜尋
    hr

    div(id="planning-table")
      vuetable(ref="vuetable"
      :api-url="`${server}/api/refill-order/`"
      data-path=""
      pagination-path=""
      :fields="fields"
      :api-mode="true"
      :css="boostrapCss"
      :http-options="httpOptions"
      :append-params="moreParams"
      @vuetable:cell-clicked="onCellClicked")
        template(slot="medication-name" slot-scope="props")
          span {{ props.rowData.drug_storage.medication.code}} - {{ props.rowData.drug_storage.medication.generic_name }}
        
        template(slot="num-refill" slot-scope="props")
          span(style="color: red") {{ props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock}}
        
        template(slot="refill-box" slot-scope="props")
          span(v-if="props.rowData.drug_storage.medication.pack_content === 0") {{ props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock }} pc
          span(v-else) {{ Math.floor((props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) / props.rowData.drug_storage.medication.pack_content )}} 盒 {{ (props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) % props.rowData.drug_storage.medication.pack_content }} pc
    
    button.btn.btn-primary.mr-2(@click="deleteOrder") 刪除補藥項目
    button.btn.btn-info(@click="outputTable") 下載報告

</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import FileSaver from 'file-saver';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';


export default {
  name: 'ADCPlanningList',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: '__checkbox',
        },
        {
          name: 'drug_storage.device',
          title: '位置',
          callback: 'readablePosistion',
        },
        {
          name: 'drug_storage.medication.code',
          title: '藥碼',
        },
        {
          name: 'drug_storage.medication.CGMH_number',
          title: '料位號',
        },
        {
          name: 'drug_storage.medication.generic_name',
          title: '學名',
        },
        // {
        //   name: '__slot:medication-name',
        //   title: '藥物',
        //   // titleClass: 'w-380',
        // },
        {
          name: 'drug_storage.patch_number',
          title: '批號',
        },
        {
          name: 'drug_storage.expired_date',
          title: '有效期限',
        },
        {
          name: 'drug_storage.stock',
          title: '目前存量',
        },
        {
          name: 'drug_storage.max_stock',
          title: '最大存量',
        },
        // {
        //   name: '__slot:num-refill',
        //   title: '待補數量',
        // },
        {
          name: '__slot:refill-box',
          title: '待補量',
        },
      ],
      systems: [],
      systemId: undefined,
      moreParams: {},
    };
  },
  components: {
    Vuetable,
  },
  async mounted() {
    await this.getSystem();
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    getSystem() {
      return this.instance.get('/api/system/', {
        params: {
          type: 'ADC',
        },
      })
      .then((res) => {
        this.systems = res.data.results;
      });
    },
    onFilterSet() {
      this.moreParams = {
        drug_storage__device__net__system: this.systemId,
      };
      const vm = this;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    deleteOrder() {
      const selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '刪除補藥規劃中...',
          confirm: false,
        });
        const promises = [];
        selected.forEach((id) => {
          promises.push(this.instance.delete(`/api/refill-order/${id}/`));
        });
        axios.all(promises)
        .then((res) => {
          this.$refs.vuetable.refresh();
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '刪除成功',
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項補藥規劃',
          confirm: true,
        });
      }
    },
    readablePosistion(val) {
      let pos = `${val.net.system.name}-${val.net.open_times}藥櫃-${val.net.row_id}層`;
      if (val.pos_row !== 0) {
        pos = `${pos}-${val.pos_row}列-${val.relative_col}行`;
      }
      return pos;
    },
    outputTable() {
      this.instance.get('/export-refill-table/', {
        params: {
          system: this.systemId,
        },
        responseType: 'blob',
      })
      .then((res) => {
        FileSaver.saveAs(res.data, 'AUTOIX-補藥清單.xlsx');
      });
    },
  },
  computed: mapState({
    instance: state => state.instance,
    drugStorageChangedTime: state => state.drugInDevice.drugStorageChangedTime,
  }),
  watch: {
    drugStorageChangedTime(val) {
      console.log(val);
      this.$refs.vuetable.refresh();
    },
  },
};
</script>

<style lang="sass">
.w-380
  width: 380px
</style>




// WEBPACK FOOTER //
// PlanningList.vue?2130bba2